import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps'

export const GoogleMap = ({
  lat,
  lng,
  showMarker = true,
  defaultZoom = 17,
}: {
  lat: number
  lng: number
  showMarker?: boolean
  defaultZoom?: number
}) => {
  const position = { lat, lng }
  return (
    <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY as string} libraries={['marker']}>
      <Map defaultCenter={position} defaultZoom={defaultZoom}>
        {showMarker && <Marker key={0} position={position} />}
      </Map>
    </APIProvider>
  )
}
